import { useEffect, useState } from 'react'

export const usePageVisibility = (): boolean => {
  const [isVisible, setIsVisible] = useState(() => !document.hidden)

  useEffect(() => {
    const handleVisibilityChange = (): void => {
      setIsVisible(!document.hidden)
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [])

  return isVisible
}

export default usePageVisibility
